export default __webpack_public_path__ + "static/closing-door-88b5f404a751679259c61b0d1e45c364.svg";